import React, { useState } from 'react';
import { FieldArray } from 'redux-form';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import RenderTargetArray from './RenderTargetArray';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        remove,
        setIsManualChangeValue,
        isManualChangeValue,
        setTargetManualChangeValue,
        targetManualChangeValue,
        programBookId,
    } = props;
    return (
        <ul className={classNames(styles.ul, remove ? styles.removeStyle : styles.shortTermWrap)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    remove={remove}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    setIsManualChangeValue={setIsManualChangeValue}
                    isManualChangeValue={isManualChangeValue}
                    setTargetManualChangeValue={setTargetManualChangeValue}
                    targetManualChangeValue={targetManualChangeValue}
                    programBookId={programBookId}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    remove: boolean;
    isLast: boolean;
    isNotFirst: boolean;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    programBookId?: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    remove,
    index,
    fields,
    isLast,
    isNotFirst,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    programBookId,
}) => {
    const row = fields.get(index);
    const [isHide, setHide] = useState(true);

    return row.status !== 2 ? (
        <li className={classNames('w-100', styles.itemLi, +row.isHidden == 1 ? styles.hidden : '')} key={index}>
            <div className={classNames(styles.treeview__level, styles.shortTermWrap)} data-level="ST">
                <span onClick={() => setHide(!isHide)} className={classNames(styles.leveltitle)}>
                    {row.title}
                    {isHide && row?.targets?.length ? (
                        <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faChevronDown} />
                    ) : (
                        <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faChevronUp} />
                    )}
                </span>
                <div className={classNames(styles.targetWrap)}>
                    {!isHide ? (
                        <FieldArray
                            setIsManualChangeValue={setIsManualChangeValue}
                            isManualChangeValue={isManualChangeValue}
                            setTargetManualChangeValue={setTargetManualChangeValue}
                            targetManualChangeValue={targetManualChangeValue}
                            name={`${member}.targets`}
                            component={RenderTargetArray}
                            programBookId={programBookId}
                        />
                    ) : null}
                </div>
            </div>
        </li>
    ) : (
        <li></li>
    );
};
export default RenderFieldArray;
